const dictionnaire = {
  /**
   * Sidebar
   */
  sidebar: {
    logout: { button: "Déconnexion" },
  },

  /**
   * Générale
   */
  global: {
    // Liste des pages
    start: { title: "Tableau de bord" },
    ordersToAssign: { title: "Reste à affecter" },
    ordersSearch: { title: "Historique des commandes", menu: "Historique" },
    users: { title: "Utilisateurs" },
    logsImports: { title: "Logs imports" },
    importsStats: { title: "Statistiques" },

    systemeInfos: { title: "Système" },
    depots: { title: "Dépôts" },
    activite: { title: "Activité en direct" },
    fonctionnement: { title: "Fonctionnement" },
    nouveautes: { title: "Nouveautés" },

    // Tableau et en-tête
    po: { label: "Code Magento" },
    client: { label: "Client" },
    clientK: { label: "Code client" },
    nom: { label: "Nom client" },
    status: { label: "Statut" },
    dateCre: { label: "Date" },
    address: { label: "Adresse" },
    phone: { label: "Téléphone" },
    proposition: { label: "Proposition" },
    comment: { label: "Commentaire" },
    product: { label: "Produit" },
    familly: { label: "Fam" },
    collection: { label: "Coll" },
    qt: { label: "Qté." },
    ordered: { label: "Commandé" },
    qtnotaffect: { label: "A affecter" },
    qtattente: { label: "En attente" },
    qtexped: { label: "Expédié" },
    qtcanceled: { label: "Annulé" },
    total: { label: "Total" },
    port: { label: "Port" },
    price: { label: "Prix" },
    frn: { label: "Frn." },
    ann: { label: "Ann." },
    financier: { label: "Carte club / bon cadeau" },
    date: { label: "Date" },

    // Historique
    history: { label: "Historique" },
    internalReference: { label: "Commande Y2" },
    depot: { label: "Dépôt" },
    dateCreFull: { label: "Date de création" },
    type: { label: "Type de produit" },
    qtOrdered: { label: "Qté. commandée" },
    qtc: { label: "Qté. demandée" },
    qte: { label: "Qté. expédiée" },
    qtr: { label: "Qté. refusée" },
    estPortTrue: { label: "Port et traitement" },
    estFinancierTrue: { label: "Carte club ou bon cadeau" },
    estFinancierFalse: { label: "Marchandise" },
    detail: { label: "Détail de la commande N°" },

    // Journal des modifications (fusion Workflow + Historique d'affectation)
    user: { label: "Utilisateur" },
    affectePar: { label: "Affecté par" },
    affectationProposition: { label: "Proposition initiale" },
    affectationDemande: { label: "Demande soumise" },
    fournisseur: { label: "Fournisseur" },
    annulation: { label: "Annulation" },
    workflowEmpty: { label: "Aucun événement enregistré pour le moment" },
    journalModifications: { label: "Journal des modifications" },
    source: { label: "Source" },
    historyTypeImport: { label: "Import Magento" },
    historyTypeAffectation: { label: "Affectation" },
    historyTypeStatutY2: { label: "Retour Y2" },
    retourY2Ws: { label: "Création dans Y2" },
    retourY2WsErreur: { label: "Erreur à la création dans Y2" },
    retourY2Livraison: { label: "Livraison" },
    retourY2Refus: { label: "Refus" },
    retourY2Annulation: { label: "Annulation" },
    retourY2Number: { label: "N° Y2" },

    // Boutons d'action
    clear: { button: "Réinitialiser" },
    affect: { button: "Affecter" },
    next: { button: "Suivant" },
    previous: { button: "Précédent" },
    complete: { button: "Completer" },
    remove: { button: "Effacer" },
    close: { button: "Fermer" },

    // Pagination
    result: { label: "Résultat" },

    // Autres
    placeholder: { input: "Rechercher..." },
  },

  /**
   * Compte et session
   */
  account: {
    sso: {
      button: "Se connecter avec Microsoft",
      error: {
        denied: "Connexion Microsoft annulée",
        noemail: "Impossible de récupérer l'email Microsoft",
        nouser: "Aucun compte associé à cet email Microsoft",
        error: "Erreur lors de la connexion Microsoft",
      },
    },
  },
};
export { dictionnaire };

